// Azərbaycan mobil nömrələri üçün ümumi format util-ləri
// Format: +994 XX XXX XX XX
// İstifadə: istənilən input komponentində (formik, useState, redux və s.)

export const PHONE_PREFIX = "+994 ";

/**
 * İstənilən xam dəyəri (rəqəm, string, əvvəlki format fərq etməz)
 * "XX XXX XX XX" formatına salır.
 * - "994" prefiksi təkrarlanmasın deyə atılır
 * - əvvəldəki "0"-lar silinir (055... -> 55...)
 * - maksimum 9 rəqəmlə məhdudlaşdırılır
 */
export function formatAzPhoneDigits(rawValue) {
  let d = String(rawValue || "").replace(/\D/g, "");

  if (d.startsWith("994")) {
    d = d.slice(3);
  }

  d = d.replace(/^0+/, "");
  d = d.slice(0, 9);

  const parts = [];
  if (d.length > 0) parts.push(d.slice(0, 2));
  if (d.length > 2) parts.push(d.slice(2, 5));
  if (d.length > 5) parts.push(d.slice(5, 7));
  if (d.length > 7) parts.push(d.slice(7, 9));

  return parts.join(" ");
}

/**
 * Saxlanılan/gələn dəyəri ("55 541 47 50" və ya "994555414750" və s.)
 * ekranda göstərmək üçün "+994 XX XXX XX XX" formatına salır.
 * Dəyər boşdursa boş string qaytarır (prefiks məcburi göstərilmir).
 */
export function getPhoneDisplayValue(rawValue) {
  const formatted = formatAzPhoneDigits(rawValue);
  return formatted ? `${PHONE_PREFIX}${formatted}` : "";
}

/**
 * TextField-in onChange event-indən (və ya birbaşa string dəyərdən)
 * saxlanılacaq formatlı dəyəri qaytarır.
 * Qaytarılan dəyəri birbaşa state/formik-ə yazmaq kifayətdir.
 */
export function handlePhoneChangeValue(inputValue) {
  const formatted = formatAzPhoneDigits(inputValue);
  return formatted ? `${PHONE_PREFIX}${formatted}` : "";
}

/**
 * Backspace ilə "+994 " prefiksinin özünün silinməsinin qarşısını almaq üçün.
 * onKeyDown-da çağırılır, true qaytararsa e.preventDefault() edilməlidir.
 */
export function shouldBlockPhoneBackspace(currentValue) {
  return String(currentValue || "").length <= PHONE_PREFIX.length;
}

/**
 * Hazır React event handler-ləri yaratmaq üçün factory.
 * Formik, useState, redux fərq etmir — yalnız dəyəri necə
 * yazacağınızı bildirən bir "setValue" funksiyası verirsiniz.
 *
 * İstifadə nümunəsi (formik):
 *   const phoneHandlers = createPhoneInputHandlers((val) =>
 *     formik.setFieldValue("phone", val)
 *   );
 *   <TextField
 *     value={getPhoneDisplayValue(formik.values.phone)}
 *     onChange={phoneHandlers.onChange}
 *     onKeyDown={phoneHandlers.onKeyDown}
 *     onFocus={phoneHandlers.onFocus}
 *   />
 *
 * İstifadə nümunəsi (adi useState):
 *   const [phone, setPhone] = useState("");
 *   const phoneHandlers = createPhoneInputHandlers(setPhone);
 */
export function createPhoneInputHandlers(setValue) {
  return {
    onChange: (e) => {
      setValue(handlePhoneChangeValue(e.target.value));
    },
    onKeyDown: (e) => {
      if (e.key === "Backspace" && shouldBlockPhoneBackspace(e.target.value)) {
        e.preventDefault();
        setValue("");
      }
    },
    onFocus: (e) => {
      if (!e.target.value) {
        setValue(PHONE_PREFIX);
      }
    },
  };
}